module.exports = __webpack_public_path__ + "static/media/icon-nfts.46e9322b.png";